//  Copyright (c) 1990-2014 David Caldwell,  All Rights Reserved.

var lib = require('./lib'), merge_into=lib.merge_into;

var color_kind = ["Main", "Light", "Lightest", "Dark", "Darkest", "NumberOfColorKinds"];
function ClipMultiply(a,b) {return (a)*(b)>255?254:(a)*(b)}
function ClipAdd(a,b)      {return (a)+(b)>255?254:(a)+(b)}
function ClipSubtract(a,b) {return (a)-(b)<0?1:(a)-(b)}
function MySetColor(kind, main) {
    var color = { r:main.r, g:main.g, b:main.b };

    switch(kind) {
        case "Main":     break;
        case "Light":    color.r = ClipAdd(color.r, 0x55);//ClipMultiply(color.red,   1.20);
                         color.g = ClipAdd(color.g, 0x55);//ClipMultiply(color.green, 1.20);
                         color.b = ClipAdd(color.b, 0x55);//ClipMultiply(color.blue,  1.20);
                         break;
        case "Lightest": color.r = ClipAdd(color.r, 0x88);//ClipMultiply(color.red,   1.40);
                         color.g = ClipAdd(color.g, 0x88);//ClipMultiply(color.green, 1.40);
                         color.b = ClipAdd(color.b, 0x88);//ClipMultiply(color.blue,  1.40);
                         break;
        case "Dark":     color.r = ClipSubtract(color.r, 0x55);//ClipMultiply(color.red,   .75);
                         color.g = ClipSubtract(color.g, 0x55);//ClipMultiply(color.green, .75);
                         color.b = ClipSubtract(color.b, 0x55);//ClipMultiply(color.blue,  .75);
                         break;
        case "Darkest":  color.r = ClipSubtract(color.r, 0x88);//ClipMultiply(color.red,   .35);
                         color.g = ClipSubtract(color.g, 0x88);//ClipMultiply(color.green, .35);
                         color.b = ClipSubtract(color.b, 0x88);//ClipMultiply(color.blue,  .35);
                         break;
    }
    return color;
}

// This is you basic square piece. Depending on its neighbors, some of the corner
// colors change. Each number below is a vertex that we will use to draw the piece.
// 0---1--------------2---3-16
// |\  |              |  /|
// | \ |              | / |
// 4__\5______________6/__7
// |   |              |   |
// |   |              |   |
// |   |              |   |
// |   |              |   |
// |   |              |   |
// |   |              |   |
// |   |              |   |
// 8---9-------------10--11
// |  /|              |\  |
// | / |              | \ |
// 12__13____________14__15-17
// 18                    19

function DrawThreeDSquare(ctx, ox,oy,size,height,border,main_color,N,S,E,W, color_func)
{
    // coords gets initialized in a loop below. You use it to turn vertex numbers (like the drawing above)
    // into real corrdinates to draw on the screen.
    var coords = [];
    color_func = color_func || MySetColor;

    // You might notice some of these are square when they "should be" triangles. Canvas has stitching issues
    // when to polygons share a diagonal boundary. Making the poly that draws first bigger than it needs to be
    // fixes the issue.
    var Poly = [{ vertex: [ 0, 1, 5, 4 ],     color: (N ? "Light"    : "Lightest" )},
                { vertex: [ 5, 1, 2, 6 ],     color: (N ? "Main"     : "Lightest" )},
                { vertex: [ 6, 2, 3, 7 ],     color: (N ? "Dark"     : "Lightest" )},
                { vertex: [ 6, 3,16, 7 ],     color: (E ? "Lightest" : "Dark"     )},
                { vertex: [10, 6, 7,11 ],     color: (E ? "Main"     : "Dark"     )},
                { vertex: [14,10,11,17,15 ],  color: (E ? "Darkest"  : "Dark"     )},
                { vertex: [14,10,15,19 ],     color: (S ? "Dark"     : "Darkest"  )},
                { vertex: [13, 9,10,14 ],     color: (S ? "Main"     : "Darkest"  )},
                { vertex: [18, 8, 9,13 ],     color: (S ? "Light"    : "Darkest"  )},
                { vertex: [12, 8, 9 ],        color: (W ? "Darkest"  : "Light"    )},
                { vertex: [ 8, 4, 5, 9 ],     color: (W ? "Main"     : "Light"    )},
                { vertex: [ 4, 0, 5 ],        color: (W ? "Lightest" : "Light"    )},
                { vertex: [ 9, 5, 6,10 ],     color:      "Main"     }  // Always
               ];

    for (var i=0;i<4;i++) {
        var y=0;
        switch (i) {
            case 0: y = oy; break;
            case 1: y = oy+height; break;
            case 2: y = oy+size-height; if(!S||1) y-=border; break;
            case 3: y = oy+size; if(!S||1) y-=border; break;
        }
        coords[i*4+0] = { x: ox            , y: y };
        coords[i*4+1] = { x: ox+height     , y: y };
        coords[i*4+2] = { x: ox+size-height, y: y };
        coords[i*4+3] = { x: ox+size       , y: y };
        if (!E||1) {
            coords[i*4+2].x -= border;
            coords[i*4+3].x -= border;
        }
    }
    coords[16]=merge_into({},coords[3]);
    coords[17]=merge_into({},coords[15]);
    coords[18]=merge_into({},coords[12]);
    coords[19]=merge_into({},coords[15]);
    if (S) {
        coords[13].y += border;
        coords[14].y += border;
        coords[18].y += border;
        coords[19].y += border;
    }
    if (E) {
        coords[ 7].x += border;
        coords[11].x += border;
        coords[16].x += border;
        coords[17].x += border;
    }

    // Construct the polygons and draw them into our new sprite...
    for (var i=0; i<Poly.length; i++) {
        var c = color_func(Poly[i].color,main_color);
        ctx.beginPath();
        for (var p=0; p<Poly[i].vertex.length; p++)
            ctx[p == 0 ? "moveTo" : "lineTo"](coords[Poly[i].vertex[p]].x,
                                              coords[Poly[i].vertex[p]].y);
        ctx.fillStyle = "rgb("+c.r+","+c.g+","+c.b+(c.a != undefined ? ","+c.a : '')+")";
        ctx.fill();
    }
}

module.exports = DrawThreeDSquare;
//  Copyright (c) 1990-2014 David Caldwell,  All Rights Reserved.

var lib = require('./lib'), merge_into=lib.merge_into;

var color_kind = ["Main", "Light", "Lightest", "Dark", "Darkest", "NumberOfColorKinds"];
function ClipMultiply(a,b) {return (a)*(b)>255?254:(a)*(b)}
function ClipAdd(a,b)      {return (a)+(b)>255?254:(a)+(b)}
function ClipSubtract(a,b) {return (a)-(b)<0?1:(a)-(b)}
function MySetColor(kind, main) {
    var color = { r:main.r, g:main.g, b:main.b };

    switch(kind) {
        case "Main":     break;
        case "Light":    color.r = ClipAdd(color.r, 0x55);//ClipMultiply(color.red,   1.20);
                         color.g = ClipAdd(color.g, 0x55);//ClipMultiply(color.green, 1.20);
                         color.b = ClipAdd(color.b, 0x55);//ClipMultiply(color.blue,  1.20);
                         break;
        case "Lightest": color.r = ClipAdd(color.r, 0x88);//ClipMultiply(color.red,   1.40);
                         color.g = ClipAdd(color.g, 0x88);//ClipMultiply(color.green, 1.40);
                         color.b = ClipAdd(color.b, 0x88);//ClipMultiply(color.blue,  1.40);
                         break;
        case "Dark":     color.r = ClipSubtract(color.r, 0x55);//ClipMultiply(color.red,   .75);
                         color.g = ClipSubtract(color.g, 0x55);//ClipMultiply(color.green, .75);
                         color.b = ClipSubtract(color.b, 0x55);//ClipMultiply(color.blue,  .75);
                         break;
        case "Darkest":  color.r = ClipSubtract(color.r, 0x88);//ClipMultiply(color.red,   .35);
                         color.g = ClipSubtract(color.g, 0x88);//ClipMultiply(color.green, .35);
                         color.b = ClipSubtract(color.b, 0x88);//ClipMultiply(color.blue,  .35);
                         break;
    }
    return color;
}

// This is you basic square piece. Depending on its neighbors, some of the corner
// colors change. Each number below is a vertex that we will use to draw the piece.
// 0---1--------------2---3-16
// |\  |              |  /|
// | \ |              | / |
// 4__\5______________6/__7
// |   |              |   |
// |   |              |   |
// |   |              |   |
// |   |              |   |
// |   |              |   |
// |   |              |   |
// |   |              |   |
// 8---9-------------10--11
// |  /|              |\  |
// | / |              | \ |
// 12__13____________14__15-17
// 18                    19

function DrawThreeDSquare(ctx, ox,oy,size,height,border,main_color,N,S,E,W, color_func)
{
    // coords gets initialized in a loop below. You use it to turn vertex numbers (like the drawing above)
    // into real corrdinates to draw on the screen.
    var coords = [];
    color_func = color_func || MySetColor;

    // You might notice some of these are square when they "should be" triangles. Canvas has stitching issues
    // when to polygons share a diagonal boundary. Making the poly that draws first bigger than it needs to be
    // fixes the issue.
    var Poly = [{ vertex: [ 0, 1, 5, 4 ],     color: (N ? "Light"    : "Lightest" )},
                { vertex: [ 5, 1, 2, 6 ],     color: (N ? "Main"     : "Lightest" )},
                { vertex: [ 6, 2, 3, 7 ],     color: (N ? "Dark"     : "Lightest" )},
                { vertex: [ 6, 3,16, 7 ],     color: (E ? "Lightest" : "Dark"     )},
                { vertex: [10, 6, 7,11 ],     color: (E ? "Main"     : "Dark"     )},
                { vertex: [14,10,11,17,15 ],  color: (E ? "Darkest"  : "Dark"     )},
                { vertex: [14,10,15,19 ],     color: (S ? "Dark"     : "Darkest"  )},
                { vertex: [13, 9,10,14 ],     color: (S ? "Main"     : "Darkest"  )},
                { vertex: [18, 8, 9,13 ],     color: (S ? "Light"    : "Darkest"  )},
                { vertex: [12, 8, 9 ],        color: (W ? "Darkest"  : "Light"    )},
                { vertex: [ 8, 4, 5, 9 ],     color: (W ? "Main"     : "Light"    )},
                { vertex: [ 4, 0, 5 ],        color: (W ? "Lightest" : "Light"    )},
                { vertex: [ 9, 5, 6,10 ],     color:      "Main"     }  // Always
               ];

    for (var i=0;i<4;i++) {
        var y=0;
        switch (i) {
            case 0: y = oy; break;
            case 1: y = oy+height; break;
            case 2: y = oy+size-height; if(!S||1) y-=border; break;
            case 3: y = oy+size; if(!S||1) y-=border; break;
        }
        coords[i*4+0] = { x: ox            , y: y };
        coords[i*4+1] = { x: ox+height     , y: y };
        coords[i*4+2] = { x: ox+size-height, y: y };
        coords[i*4+3] = { x: ox+size       , y: y };
        if (!E||1) {
            coords[i*4+2].x -= border;
            coords[i*4+3].x -= border;
        }
    }
    coords[16]=merge_into({},coords[3]);
    coords[17]=merge_into({},coords[15]);
    coords[18]=merge_into({},coords[12]);
    coords[19]=merge_into({},coords[15]);
    if (S) {
        coords[13].y += border;
        coords[14].y += border;
        coords[18].y += border;
        coords[19].y += border;
    }
    if (E) {
        coords[ 7].x += border;
        coords[11].x += border;
        coords[16].x += border;
        coords[17].x += border;
    }

    // Construct the polygons and draw them into our new sprite...
    for (var i=0; i<Poly.length; i++) {
        var c = color_func(Poly[i].color,main_color);
        ctx.beginPath();
        for (var p=0; p<Poly[i].vertex.length; p++)
            ctx[p == 0 ? "moveTo" : "lineTo"](coords[Poly[i].vertex[p]].x,
                                              coords[Poly[i].vertex[p]].y);
        ctx.fillStyle = "rgb("+c.r+","+c.g+","+c.b+(c.a != undefined ? ","+c.a : '')+")";
        ctx.fill();
    }
}

module.exports = DrawThreeDSquare;
